<template>
  <layout-main-inner title="库存数据">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <ent-warehouse-auto-select
          v-model="config.warehouseNo"
          :callback="() => {handleCurrentChange(1)}" />
        <ent-product-auto-select
          v-model="config.skuId"
          style="margin-left: 10px;"
          :productTypes="[1,2,3,9]"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model.trim="config.skuMsg"
          placeholder="请输入商品名称/编码"
          clearable=""
          style="width: 220px;margin-left: 10px;">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          prop="skuName"
          min-width="140"
          :resizable="false"
          label="商品名称">
        </el-table-column>
        <el-table-column
          width="120"
          label="商品编码"
          :resizable="false"
          prop="skuCode"></el-table-column>
        <el-table-column
          width="100"
          label="可用库存"
          :resizable="false"
          prop="num">
          <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
        </el-table-column>
        <el-table-column
          width="100"
          label="冻结库存"
          :resizable="false"
          prop="frozenNum">
          <template slot-scope="{row}">{{ row.frozenNum }} {{ row.measureUnit | measureUnitName() }}</template>
        </el-table-column>
        <el-table-column
          label="仓库"
          width="160"
          :resizable="false"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="部门"
          min-width="180"
          :resizable="false"
          prop="ownerCode">
          <template slot-scope="{row}">
            {{ row.ownerCode | departmentName() }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="更新时间"
          width="140"
          :resizable="false"
          prop="updateTime">
          <template slot-scope="{row}">
            {{ row.updateTime | dateformat() }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="安全库存"
          :resizable="false"
          width="120">
          <template slot-scope="{row}">
            <span style="margin-right:5px;">{{ row.num }}</span> -->
        <!-- <safe-inventory-popover :value="row.num" /> -->
        <!-- </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="操作"
          width="105">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click="viewDetail(row)">安全库存</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import EntWarehouseAutoSelect from '../../components/business/ent-warehouse-auto-select.vue'
// import SafeInventoryPopover from './safe-inventory-popover.vue'

export default {
  name: 'InventoryList',
  components: { EntProductAutoSelect, EntWarehouseAutoSelect },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        skuId: null,
        warehouseNo: '',
        skuMsg: ''
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/stocklist', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    viewDetail(row) {
      console.log(row)
    },
    stockCount(row) {
      console.log(row)
    }
  }
}
</script>
